// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let WizardFormUtils = require("../../common/Form/WizardFormUtils.bs.js");
let Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");
let PropertyWizardFormRelay__Elements = require("./PropertyWizardFormRelay__Elements.bs.js");
let PropertyWizardRelayDescriptionMessage_draft_graphql = require("../../../__generated__/PropertyWizardRelayDescriptionMessage_draft_graphql.bs.js");

let convertFragment = PropertyWizardRelayDescriptionMessage_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayDescriptionMessage_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescriptionMessage_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayDescriptionMessage_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayDescriptionMessage_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__Description__Message(props) {
  let message = props.message;
  let match = PropertyWizardFormRelay.Context.use();
  let mode = match.mode;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescriptionMessage_draft_graphql.node, convertFragment, props.draft);
  let match$1 = React.useState(() => draft.message);
  let tmp;
  tmp = typeof mode !== "object" || mode.TAG !== "Rebroadcast" ? "optional" : undefined;
  let tmp$1;
  tmp$1 = typeof mode !== "object" || mode.TAG !== "Rebroadcast" ? "For example: Professional photos coming Thursday, in process of going through \"make-ready\" but will show now by appointment, interior not ready for showing until estate removes items from property." : "For example: 1267 North is back on the market, and priced well for the perfect renovation opportunity. Available this weekend by appointment. Call Mike to schedule an appointment 415-853-3098.";
  let tmp$2;
  tmp$2 = typeof mode !== "object" || mode.TAG !== "Rebroadcast" ? "Use this if there's anything else you'd like your TAN colleagues to know. It is not shared with clients." : "Tell your TAN colleagues why you're rebroadcasting this property. This message is not shared with clients.";
  return JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
    width: 12,
    children: [
      JsxRuntime.jsx(PropertyWizardFormRelay__Elements.RichTextEditorField.make, {
        onFocus: param => message.onFocus(),
        labelText: "Message for TAN colleagues",
        optionalText: tmp,
        placeholderText: tmp$1,
        helpText: tmp$2,
        onChange: param => message.onChange(WizardFormUtils.noneIfEmpty(param.content)),
        onBlur: param => message.onBlur(),
        initialContent: match$1[0],
        status: message.status
      }),
      JsxRuntime.jsx(Form__Components.FieldError.make, {
        valid: message.valid
      })
    ]
  });
}

let Components;

let TextInputField;

let Cell;

let Validators;

let FormUtils;

let Elements;

let make = PropertyWizardRelay__Description__Message;

exports.Components = Components;
exports.TextInputField = TextInputField;
exports.Cell = Cell;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.Elements = Elements;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* react Not a pure module */
